import { ArrowForward, ArrowRight, ArrowRightAlt } from "@mui/icons-material";
import {
  Grid,
  Stack,
  Typography,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Button,
  Box,
} from "@mui/material";
import { createApplication } from "apis/controllers/applications";
import { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  // createApplication,
  // getAdditionalInstitutes,
  // getInstitutes,
  getApplications,
} from "src/apis/controllers/applications";
import { useLoading } from "src/hooks/useLoading";
import AutocompleteCheckboxes from "src/qubCommon/Inputs/AutoCompleteCheckboxes";

const NewApplicationPanel = (props) => {
  const form = useForm();
  const { settings, applicationTypes, visible } = props;
  const [selected, setSelected] = useState(null);
  const [redirectTo, setRedirectTo] = useState('application');
  const handleChange = (id, redirect) => {
    if (selected === id) {
      setSelected(null);
      setRedirectTo(null)
    } else {
      setSelected(id);
      setRedirectTo(redirect)
    }
  };
  const { setLoading } = useLoading();

  const navigate = useNavigate();

  const handleCreateApplication = async (data) => {
    console.log(data, selected, "Mel")
    if (!selected) {
      return;
    }
    try {
      setLoading(true);
      const res = await createApplication({ typeId: selected });
      if (res?.status === "success") navigate(`/${redirectTo}/${res?.data?.id}`);
      setLoading(false);
    } catch (e) {
      console.log("Error creating application:", e);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={visible ? "card with-slide open" : " card with-slide closed"}
    >
      <div className="card-header">
        <h4>
          <b>Λεπτομέρειες Αίτησης</b>
        </h4>
      </div>
      <div className="card-body">
        <Grid container>
          <Grid item xs={12} >
            <Stack direction="column">
              <Typography>Τύπος Αίτησης:</Typography>
              <FormGroup>
                {applicationTypes?.map((item) => {
                  const disabled = !item?.canCreate;
                  const reason = item?.message ?? "";

                  if (item?.redirectTo !== 'student-application') return (
                    <Box
                      key={item.id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 1,
                        opacity: disabled ? 0.7 : 1,
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={disabled}
                            checked={selected === item.id}
                            onChange={() => handleChange(item.id, item?.redirectTo)}
                          />
                        }
                        label={
                          <Typography sx={{ whiteSpace: "nowrap" }}>{item.type}</Typography>
                        }
                      />

                      {disabled && reason && (
                        <Typography
                          color='error'
                          variant="body2"
                          sx={{
                            ml: 1,
                            fontStyle: "italic",
                            fontSize: "0.85rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          ({reason})
                        </Typography>
                      )}
                    </Box>
                  );
                })}
              </FormGroup>

            </Stack>
          </Grid>

          <Grid item xs={12} md={6} hidden={!selected}>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<ArrowForward />}
              sx={{ color: "#fefefe", marginTop: "28px" }}
              onClick={form?.handleSubmit(handleCreateApplication)}
            >
              Συνέχεια
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default NewApplicationPanel;
